import { render, staticRenderFns } from "./DetailPacking.vue?vue&type=template&id=595c1b61&"
import script from "./DetailPacking.vue?vue&type=script&lang=js&"
export * from "./DetailPacking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports